import React from 'react';
import { Tooltip } from 'antd';
import { HolderOutlined } from '@ant-design/icons';
import { useDrag, useDrop } from 'react-dnd';
import { useTranslation } from 'react-i18next';
import { confirmation } from '@/components';
import styles from '../FormPathTemplate.module.scss';

const AcceptTypes = {
  TASK: 'task',
};

interface GroupDropWrapperProps {
  groupId: string;
  onDrop: (taskIndex: number, groupId: string) => void;
  children: React.ReactNode;
}

export const GroupDropWrapper: React.FC<GroupDropWrapperProps> = (props) => {
  const { groupId, onDrop, children } = props;
  const { t } = useTranslation(undefined, {
    keyPrefix: 'pathTemplates.details.groupTasks',
  });
  const [{ isOver }, drop] = useDrop({
    accept: AcceptTypes.TASK,
    collect: (monitor) => ({
      isOver: monitor.isOver({ shallow: true }),
    }),
    drop: (item: { index: number }) => {
      confirmation.show({
        title: t('move.title'),
        body: t('move.body'),
        onConfirm: () => onDrop(item.index, groupId),
      });
    },
  });
  return (
    <div
      ref={drop}
      className={styles.dropArea}
      style={{
        border: isOver ? '2px dashed #1890ff' : undefined,
        backgroundColor: isOver ? '#e6f7ff' : undefined,
      }}
    >
      {children}
    </div>
  );
};

interface DraggableTaskProps {
  index: number;
  children: React.ReactNode;
}

export const DraggableTask: React.FC<DraggableTaskProps> = (props) => {
  const { index, children } = props;
  const [, dragRef] = useDrag({
    type: AcceptTypes.TASK,
    item: { index },
  });

  const { t } = useTranslation(undefined, {
    keyPrefix: 'pathTemplates.details.groupTasks',
  });
  return (
    <div ref={dragRef} className={styles.dragArea}>
      <Tooltip title={t('toGroup.move.title')}>
        <HolderOutlined style={{ cursor: 'grab' }} />
      </Tooltip>

      {children}
    </div>
  );
};
